import { createAction, createAsyncAction } from 'typesafe-actions';

export const getContacts = createAsyncAction(
  '@GET_CONTACTS/REQUEST',
  '@GET_CONTACTS/SUCCESS',
  '@GET_CONTACTS/FAILURE'
)<{ cpf: string }, Array<UserContact>, string>();

export const getTelsAndEmails = createAsyncAction(
  '@GET_TELSANDEMAILS/REQUEST',
  '@GET_TELSANDEMAILS/SUCCESS',
  '@GET_TELSANDEMAILS/FAILURE'
)<{ cpf: string }, Array<UserContact[]>, string>();

export const sendEmail = createAsyncAction(
  '@SEND_EMAIL/REQUEST',
  '@SEND_EMAIL/SUCCESS',
  '@SEND_EMAIL/FAILURE'
)<SendEmail, string, string>();

export const selectContact = createAction('@SELECT_CONTACT')<
  UserContact | undefined
>();

export const selectContactByCpf = createAction('@SELECT_CONTACTBYCPF')<
  IUserByCpf | undefined
>();

export const clearSentEmailStatus = createAction('@CLEAR_SENT_EMAIL_STATUS')<
  undefined
>();
